import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from '@capacitor/core';

export class GoogleService {
    private static instance: GoogleService;
    private googleAuthPlugin: typeof GoogleAuth | undefined;

    constructor() {
        if (GoogleService.instance) {
            return GoogleService.instance;
        }
        this.init();
        GoogleService.instance = this;
    }

    private init() {
        console.log('Inicializando GoogleService...');
        console.log('¿Es plataforma nativa?', Capacitor.isNativePlatform());
        console.log('Plataforma:', Capacitor.getPlatform());
        console.log('GoogleAuth disponible:', !!GoogleAuth);
        
        if (Capacitor.isNativePlatform()) {
            this.googleAuthPlugin = GoogleAuth;
            console.log('Plugin GoogleAuth asignado:', !!this.googleAuthPlugin);

            try {
                // Inicialización explícita
                const initConfig = {
                    clientId: '532211224879-oih7n0tkodejspkc67ehred920ii6e2e.apps.googleusercontent.com', // Web Client ID
                    androidClientId: '532211224879-oih7n0tkodejspkc67ehred920ii6e2e.apps.googleusercontent.com', // Android Client ID
                    scopes: ['profile', 'email'],
                    grantOfflineAccess: true,
                    forceCodeForRefreshToken: true
                };
                
                console.log('Configuración de inicialización:', initConfig);
                this.googleAuthPlugin.initialize(initConfig);
                console.log('GoogleAuth.initialize() llamado exitosamente');
                
                // Verificar si el plugin está listo
                console.log('Plugin GoogleAuth listo para usar');
            } catch (initError) {
                console.error('Error al inicializar GoogleAuth:', initError);
            }
        } else {
            console.warn('No se está ejecutando en plataforma nativa');
        }
    }

    async login() {
        console.log('Intentando login con GoogleService...');
        if (!this.googleAuthPlugin) {
            console.error('Plugin GoogleAuth no disponible para login');
            return null;
        }

        // El plugin no mantiene estado de usuario, siempre necesitamos hacer signIn

        try {
            console.log('Llamando a signIn()...');
            const response = await this.googleAuthPlugin.signIn();
            console.log('Respuesta completa de signIn:', JSON.stringify(response, null, 2));
            
            if (response && response.authentication) {
                console.log('Authentication object encontrado:', response.authentication);
                console.log('ID Token:', response.authentication.idToken);
                console.log('Access Token:', response.authentication.accessToken);
                console.log('User data:', {
                    id: response.id,
                    email: response.email,
                    name: response.name,
                    givenName: response.givenName,
                    familyName: response.familyName,
                    imageUrl: response.imageUrl
                });
                console.log('User imageUrl específico:', response.imageUrl);
                console.log('User name específico:', response.name);
                
                if (response.authentication.idToken) {
                    console.log('Token obtenido exitosamente');
                    // Devolver tanto el token como los datos del usuario
                    return {
                        idToken: response.authentication.idToken,
                        user: {
                            id: response.id,
                            email: response.email,
                            name: response.name,
                            givenName: response.givenName,
                            familyName: response.familyName,
                            imageUrl: response.imageUrl
                        }
                    };
                } else {
                    console.error('ID Token está vacío o undefined');
                    return null;
                }
            } else {
                console.error('No se encontró authentication en la respuesta');
                console.error('Estructura de respuesta:', Object.keys(response || {}));
                return null;
            }
        } catch (err) {
            console.error('Error detallado en GoogleService login:', err);
            if (err instanceof Error) {
                console.error('Mensaje de error:', err.message);
                console.error('Stack trace:', err.stack);
            }
            return null;
        }
    }

    async logout() {
        if (!this.googleAuthPlugin) {
            console.warn('Plugin GoogleAuth no disponible para logout');
            return;
        }
        try {
            await this.googleAuthPlugin.signOut();
            console.log('Logout exitoso');
        } catch (err) {
            console.error('Error en GoogleService logout:', err);
        }
    }

    // Método para verificar el estado del plugin
    async checkPluginStatus() {
        console.log('Verificando estado del plugin GoogleAuth...');
        
        if (!this.googleAuthPlugin) {
            console.error('Plugin GoogleAuth no está disponible');
            return false;
        }

        console.log('Plugin GoogleAuth está disponible y listo para usar');
        return true;
    }
} 